import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import useWindowDimensions from '../../hooks/windowDimensions';
import { Icon } from '../../components/icons/icons';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/Accordion/Accordion';
import '../../styles/pages/Core.scss';
import IconHoverButton from '../../components/IconHoverButton/IconHoverButton';
import LevelIcon from '../../components/skillpath/LevelIcon';
import SkillDivider from '../../components/skillpath/SkillDivider';

export type AccordionProps = {
    id: string;
    title: string;
    content: any; /* arrays allow for complex HTML to be injected */
}
const Core = () => {
    const [isMobileClient, setIsMobileClient] = React.useState<boolean>(false);
    const { height, width } = useWindowDimensions();
    const mobileList: AccordionProps[] = [
        {
            id: "1",
            title: "FOUNDATIONAL SKILL: Attention to Detail, Quality Service",
            content: [
                <h3 className='fnt-wght-bold'>Novice: Learner</h3>,
                <p className='m-t--75 m-b--75'>Accurately self-review deliverables to identify mistakes, errors, or areas for improvement before submittal.</p>,
                <p className='m-t--75 m-b--75'>Striving to obtain minimal basic errors(spelling, grammer, formatting).</p>,
                <p className='m-t--75 m-b--75'>Ask clarifying questions for tasks when appropriate to gain a better understanding of what is being asked.</p>,
                <p className='m-t--75 m-b--75'>Show onership of work product, producing high quality work according to procedures and standards.</p>,
                <hr className='m-t-1 m-b-1' />,
                <h3 className='fnt-wght-bold'>Mid Level: Knowledge Competent / Professional</h3>,
                <p className='m-t--75 m-b--75'>Monitors work outputs and immediately identifies, reports, and corrects own and jurior staf's errors.</p>,
                <p className='m-t--75 m-b--75'>Proactively establishes or suggests, procedures/systems to identify and correct problems in work processes and outcomes.</p>,
                <hr className='m-t-1 m-b-1' />,
                <h3 className='fnt-wght-bold'>Advanced: Mentor</h3>,
                <p className='m-t--75 m-b--75'>Can't read what's behind the "i" popup in mockups.</p>
            ]
        },
        {
            id: "2",
            title: "FOUNDATIONAL SKILL: Communication",
            content: [
                <h3 className='fnt-wght-bold'>Novice: Learner</h3>,
                <p className='m-t--75 m-b--75'>Start learning how to communicate ideas clearly and concisely by avoiding technical jargon and using straightforward language that everyone can understand.</p>,
                <p className='m-t--75 m-b--75'>Understand appropriate tone and style for different types of communication (face-to-fcae, messaging, e-mail, video call, etc.).</p>,
                <p className='m-t--75 m-b--75'>Proactively update appropriate parties (team members, managers, clients, etc.) of work/project statuses, challenges, etc.</p>,
                <p className='m-t--75 m-b--75'>Become familiar with the varius types of communication platforms and when they are best used (Teams messaging, Teams video calls, Outlook, etc.).</p>,
                <h4 className='fnt-wght-bold m-b--25'>Written</h4>,
                <p className='m-b--75 m-t-0'>Proofread communication for spelling, grammer, and punctuation errors before sending in accordance with JMT's style guide.</p>,
                <p className='m-t--75 m-b--75'>Begin to understand the writing style needed for different platforms and purposes (i.e. a report, a quick email, or a formal document).</p>,
                <h4 className='fnt-wght-bold m-b--25'>Verbal</h4>,
                <p className='m-b--75 m-t-0'>Develop active listening skills to better understand messages being conveyed.</p>,
                <p className='m-t--75 m-b--75'>Be aware of ones own body language and how it affects communication.</p>,
                <hr className='m-t-1 m-b-1' />,
                <h3 className='fnt-wght-bold'>Mid Level: Knowledge Competent / Professional</h3>,
                <p className='m-t--75 m-b--75'>Adapt communication styles to the situation, audience and platform that you're communicating.</p>,
                <p className='m-t--75 m-b--75'>Create messages that are in line with the company's strategic objectives and impact decision-making processes.</p>,
                <p className='m-t--75 m-b--75'>Communicate with confidence on topics where you are a subject matter expert.</p>,
                <p className='m-t--75 m-b--75'>Identify when to use different communication platforms (such as face-to-face, messaging, or email) based on the situation.</p>,
                <h4 className='fnt-wght-bold m-b--25'>Written</h4>,
                <p className='m-b--75 m-t-0'>Be able to analyze complex data and translating it into clear, understandable written communication that meet industry/client standards.</p>,
                <p className='m-t--75 m-b--75'>Use knowledge of JMT's style guide to write communication aligned with the company's brand values.</p>,
                <h4 className='fnt-wght-bold m-b--25'>Verbal</h4>,
                <p className='m-b--75 m-t-0'>Consistently display active listening skills by fully concentrating, understanding, responding, and remembering what is being said.</p>,
                <p className='m-t--75 m-b--75'>Begin to interpret the body language of others and use it to drive communication decisions.</p>,
                <hr className='m-t-1 m-b-1' />,
                <h3 className='fnt-wght-bold'>Advanced: Mentor</h3>,
                <p className='m-t--75 m-b--75'>Simplify complex information into concise, executive-level summaries that highlight key points and decisions needed.</p>,
                <p className='m-t--75 m-b--75'>Effectively communicate messages that resonate, engage, and influence diverse audiences, both internal and external.</p>,
                <p className='m-t--75 m-b--75'>Develop communication that align with strategic business objectives and articulates the company's values clearly which shape opinions, motivate teams, and drive organizational change.</p>,
                <p className='m-t--75 m-b--75'>Able to negotiate with people in finding common ground and sharing benefits for all parties.</p>,
                <p className='m-t--75 m-b--75'>Utilize a diverse range of communication platforms to ensure everyon eis included in communication.</p>,
                <h4 className='fnt-wght-bold m-b--25'>Written</h4>,
                <p className='m-b--75 m-t-0'>Provide feedback on written communication using knwoledge of JMT's written style guide.</p>,
                <h4 className='fnt-wght-bold m-b--25'>Verbal</h4>,
                <p className='m-b--75 m-t-0'>Effectively interpret other's body language, control ones own, and use non-verbal cues to enhance communication.</p>,
                <p className='m-t--75 m-b--75'>Profanest (?) presentation delivery - using eye contact, positive body language, voice projection, reading audience ques, and minimal notes-/reading from the slide.</p>
            ]
        },
        {
            id: "3",
            title: "INTERMEDIATE SKILL: ADAPTABILITY",
            content: [
                <h3 className='fnt-wght-bold'>Novice: Learner</h3>,
                <p className='m-t--75 m-b--75'>Recognizes and adapts to change with minimal disruption to workflow and performance level after initial adjustment period.</p>,
                <p className='m-t--75 m-b--75'>May show stress but is able to regain calm and professional demeanor.</p>,
                <p className='m-t--75 m-b--75'>Collaborate with senior staff to adopt new processes or other results of change.</p>,
                <hr className='m-t-1 m-b-1' />,
                <h3 className='fnt-wght-bold'>Mid Level: Knowledge Competent / Professional</h3>,
                <p className='m-t--75 m-b--75'>Displays a positive demeanor toward change while remaining calm and professional.</p>,
                <p className='m-t--75 m-b--75'>Generates thoughtful questions toward change to better understand what's coming.</p>,
                <p className='m-t--75 m-b--75'>Utilize stressful situations as learning experiences and apply leasons learned to other situations.</p>,
                <hr className='m-t-1 m-b-1' />,
                <h3 className='fnt-wght-bold'>Advanced: Mentor</h3>,
                <p className='m-t--75 m-b--75'>Easily adapts to change while maintaing high performance levels.</p>,
                <p className='m-t--75 m-b--75'>Embraces change by understanding and explaining the why and how to others.</p>,
                <p className='m-t--75 m-b--75'>Proactively seeks out information related to change.</p>
            ]
        },
    ];

    /* #region Use Effects */

    /* are we on a mobile device? */
    useEffect(() => {
        const finalValue = isMobile || width < 1100;
        setIsMobileClient(finalValue);
    }, [width]);

    /* #endregion Use Effects */

    /* #region functions */
    const getcheckbox = (labelText: string) => {
        return (
            <label className='dis-inline-flex dis-flex-rows dis-flex-aln-center cursor-pointer'>
                <input type='checkbox' className='on-dark m-r--75' />
                {labelText}
            </label>
        );
    }

    /* #endregion functions */

    if (isMobileClient) {
        return (
            <>
                <div className='core-container'>
                    <h2 className='fnt-wght-bold m-b-1'>Core JMT Business Skills</h2>
                    <p className='m-b-1'>Become proficient in Core JMT Business Skills and your Dicipline Specific Skills, then begin to work on the other focus areas of your interest.</p>
                    <label className='dis-block m-b--50'>Speak with your manager about:</label>
                    <ul className='reset m-b-1'>
                        <li className='m-b--50'>
                            <Icon name="icon-chat-bullet" className='icon-white core-chat-bullet' /><span>What Core Business skills focus on</span>
                        </li>
                        <li>
                            <Icon name="icon-chat-bullet" className='icon-white core-chat-bullet' /><span>What level is appropriate for you based on your current job position</span>
                        </li>
                    </ul>
                    <p>Once you have become proficient, develop another area.</p>
                    <p><i className='fnt-sz-sml'>Recommended for all employees</i></p>
                    <button className='btn-white bdr-radius-0'>Select Skills</button>
                </div>
                <Accordion>
                    {
                        mobileList.map((item, index) => (
                            <AccordionItem id={item.id} key={item.id}>
                                <AccordionTrigger color="secondary" headingLevel={3}>{item.title}</AccordionTrigger>
                                <AccordionContent color="secondary">
                                    {item.content}
                                </AccordionContent>
                            </AccordionItem>
                        ))
                    }
                </Accordion>
            </>
        );
    } else {
        return (<>
            <div className='core-container desktop'>
                <div className='core-desktop-max-width'>
                    <h2 className='fnt-wght-bold m-b-1 h1-size'>Core JMT Business Skills</h2>
                </div>
                <div className='core-desktop-max-width top'>
                    <section>
                        <p className='m-b-1-5'>Become proficient in Core JMT Business Skills and your Dicipline Specific Skills.</p>
                        <label className='dis-block m-b--50'>Speak with your manager about:</label>
                        <ul className='reset m-b-1-5'>
                            <li className='m-b--50 dis-flex dis-flex-aln-center'>
                                <Icon name="icon-chat-bullet" className='icon-white core-chat-bullet' /><span>What Core Business skills focus on</span>
                            </li>
                            <li className='dis-flex dis-flex-aln-center'>
                                <Icon name="icon-chat-bullet" className='icon-white core-chat-bullet' /><span>What level is appropriate for you based on your current job position</span>
                            </li>
                        </ul>
                        <p className='m-b-1-5'>Once you have become proficient, develop another area.</p>
                        <p className='fnt-sz-sml-med'><i>Recommended for all employees</i></p>
                    </section>
                    <section>
                        <p>Select the skills you want to learn more about and view the skills matrix</p>
                        <div className='dis-flex dis-flex-rows dis-flex-jst-space-between'>
                            <div>
                                <h3 className='fnt-wght-600 m-b--75 h4-size'>Foundational Skills</h3>
                                <ul className='reset'>
                                    <li className='m-b--50'>
                                        {getcheckbox("All")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Analytical Thinking, Problem Solving")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Attention To Detail, Quality Service")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Building Relationships, Teamwork")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Communication")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Dependability")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Planning and Organizing Time Management")}
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h3 className='fnt-wght-600 m-b--75 h4-size'>Intermediate Skills</h3>
                                <ul className='reset'>
                                    <li className='m-b--50'>
                                        {getcheckbox("All")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Adapability")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Business Acumen")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Inclusivity/Belonging")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Knowledge Sharing")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Results Oriented")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Workspace Learning Initiative")}
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h3 className='fnt-wght-600 m-b--75 h4-size'>Advanced Skills</h3>
                                <ul className='reset'>
                                    <li className='m-b--50'>
                                        {getcheckbox("All")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Seller-Doer")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Emotional Intelligence")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("vision & Startegic Thinking")}
                                    </li>
                                    <li className='m-b--50'>
                                        {getcheckbox("Knowledge Sharing")}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='aln-right'>
                            <button className='btn-white bdr-radius-0'>Reset</button>
                        </div>
                    </section>
                </div>
            </div>
          <div className='core-desktop-max-width bottom p-t-1-75 p-b-1-5 sticky-top bg-white'>
                <div>&nbsp;</div>
                <div className='aln-center'>
                    <LevelIcon 
                        iconName='icon-novice' 
                        iconClassNames={['icon-secondary', 'level-icons', 'm-b--75']} 
                        levelText='Novice'
                        levelTextClassNames={['fnt-wght-900', 'fnt-sz-med-lrg', 'm-b--50']}
                        detailText='Learner'
                        detailTextClassNames={['fnt-wght-900', 'fnt-sz-sml-med']}
                    />
                </div>
                <div className='aln-center'>
                <LevelIcon 
                        iconName='icon-mid-level' 
                        iconClassNames={['icon-secondary', 'level-icons', 'm-b--75']} 
                        levelText='Mid Level'
                        levelTextClassNames={['fnt-wght-900', 'fnt-sz-med-lrg', 'm-b--50']}
                        detailText='Knowledge Competent / Professional'
                        detailTextClassNames={['fnt-wght-900', 'fnt-sz-sml-med']}
                    />
                </div>
                <div className='aln-center'>
                <LevelIcon 
                        iconName='icon-advanced' 
                        iconClassNames={['icon-secondary', 'level-icons', 'm-b--75']} 
                        levelText='Advanced'
                        levelTextClassNames={['fnt-wght-900', 'fnt-sz-med-lrg', 'm-b--50']}
                        detailText='Mentor'
                        detailTextClassNames={['fnt-wght-900', 'fnt-sz-sml-med']}
                    />
                </div>
            </div>
            <SkillDivider 
                dividerClassNames={['bg-secondary', 'p-t--50', 'p-b--50', 'skill-divider-container']}
                headingLevel={4}
                skillLevels={undefined}
                headingClassNames={['clr-white', 'fnt-wght-500', 'm-0']}
                dividerText='FOUNDATIONAL SKILL: Attention To Detail, Quality Service'
                tooltipContent={""}
            />
            <div className='core-desktop-max-width bottom'>
                <div className='bordered-cell'>
                    <IconHoverButton
                        isLink={true}
                        linkURL='/bookmarks'
                        buttonClassName='m-t--75 gap--25 p--50 bdr-radius--25'
                        buttonClassHoverName='bg-primary'
                        iconClassName='icon-primary bookmark-icons'
                        buttonOnClick={null}
                        iconHoverClassName='icon-white bookmark-icons'
                        iconName='icon-bookmarked-skill'
                        iconHoverName='icon-bookmarked-skill'
                        buttonText='View Bookmarks'
                        buttonTextClassName='wht-spc-no-wrap clr-primary fnt-wght-500'
                        buttonTextHoverClassName='clr-white' />
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Accurately self-review deliverables to identify mistakes, errors, or areas for improvement before submittal.</p>
                    <p className='m-t--75 m-b--75'>Striving to obtain minimal basic errors(spelling, grammer, formatting).</p>
                    <p className='m-t--75 m-b--75'>Ask clarifying questions for tasks when appropriate to gain a better understanding of what is being asked.</p>
                    <p className='m-t--75 m-b--75'>Show onership of work product, producing high quality work according to procedures and standards.</p>
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Monitors work outputs and immediately identifies, reports, and corrects own and jurior staf's errors.</p>
                    <p className='m-t--75 m-b--75'>Proactively establishes or suggests, procedures/systems to identify and correct problems in work processes and outcomes.</p>
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Can't read what's behind the "i" popup in mockups.</p>
                </div>
            </div>
            <SkillDivider 
                dividerClassNames={['bg-secondary', 'p-t--50', 'p-b--50', 'skill-divider-container']}
                headingLevel={4}
                skillLevels={undefined}
                headingClassNames={['clr-white', 'fnt-wght-500', 'm-0']}
                dividerText='FOUNDATIONAL SKILL: Communication'
                tooltipContent={""}
            />
            <div className='core-desktop-max-width bottom'>
                <div className='bordered-cell'>
                    <IconHoverButton
                        isLink={true}
                        linkURL='/bookmarkSkill'
                        buttonClassName='m-t--75 gap--25 p--50 bdr-radius--25'
                        buttonClassHoverName='bg-primary'
                        iconClassName='icon-primary bookmark-icons'
                        buttonOnClick={null}
                        iconHoverClassName='icon-white bookmark-icons'
                        iconName='icon-bookmark-skill'
                        iconHoverName='icon-bookmark-skill'
                        buttonText='Bookmark Skill'
                        buttonTextClassName='wht-spc-no-wrap clr-primary fnt-wght-500'
                        buttonTextHoverClassName='clr-white' />
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Start learning how to communicate ideas clearly and concisely by avoiding technical jargon and using straightforward language that everyone can understand.</p>
                    <p className='m-t--75 m-b--75'>Understand appropriate tone and style for different types of communication (face-to-fcae, messaging, e-mail, video call, etc.).</p>
                    <p className='m-t--75 m-b--75'>Proactively update appropriate parties (team members, managers, clients, etc.) of work/project statuses, challenges, etc.</p>
                    <p className='m-t--75 m-b--75'>Become familiar with the varius types of communication platforms and when they are best used (Teams messaging, Teams video calls, Outlook, etc.).</p>
                    <h4 className='fnt-wght-800 ltr-spcng-normal m-b-0'>Written</h4>
                    <p className='m-b--75 m-t-0'>Proofread communication for spelling, grammer, and punctuation errors before sending in accordance with JMT's style guide.</p>
                    <p className='m-t--75 m-b--75'>Begin to understand the writing style needed for different platforms and purposes (i.e. a report, a quick email, or a formal document).</p>
                    <h4 className='fnt-wght-800 ltr-spcng-normal m-b-0'>Verbal</h4>
                    <p className='m-b--75 m-t-0'>Develop active listening skills to better understand messages being conveyed.</p>
                    <p className='m-t--75 m-b--75'>Be aware of ones own body language and how it affects communication.</p>
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Adapt communication styles to the situation, audience and platform that you're communicating.</p>
                    <p className='m-t--75 m-b--75'>Create messages that are in line with the company's strategic objectives and impact decision-making processes.</p>
                    <p className='m-t--75 m-b--75'>Communicate with confidence on topics where you are a subject matter expert.</p>
                    <p className='m-t--75 m-b--75'>Identify when to use different communication platforms (such as face-to-face, messaging, or email) based on the situation.</p>
                    <h4 className='fnt-wght-800 ltr-spcng-normal m-b-0'>Written</h4>
                    <p className='m-b--75 m-t-0'>Be able to analyze complex data and translating it into clear, understandable written communication that meet industry/client standards.</p>
                    <p className='m-t--75 m-b--75'>Use knowledge of JMT's style guide to write communication aligned with the company's brand values.</p>
                    <h4 className='fnt-wght-800 ltr-spcng-normal m-b-0'>Verbal</h4>
                    <p className='m-b--75 m-t-0'>Consistently display active listening skills by fully concentrating, understanding, responding, and remembering what is being said.</p>
                    <p className='m-t--75 m-b--75'>Begin to interpret the body language of others and use it to drive communication decisions.</p>
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Simplify complex information into concise, executive-level summaries that highlight key points and decisions needed.</p>
                    <p className='m-t--75 m-b--75'>Effectively communicate messages that resonate, engage, and influence diverse audiences, both internal and external.</p>
                    <p className='m-t--75 m-b--75'>Develop communication that align with strategic business objectives and articulates the company's values clearly which shape opinions, motivate teams, and drive organizational change.</p>
                    <p className='m-t--75 m-b--75'>Able to negotiate with people in finding common ground and sharing benefits for all parties.</p>
                    <p className='m-t--75 m-b--75'>Utilize a diverse range of communication platforms to ensure everyon eis included in communication.</p>
                    <h4 className='fnt-wght-800 ltr-spcng-normal m-b-0'>Written</h4>
                    <p className='m-b--75 m-t-0'>Provide feedback on written communication using knwoledge of JMT's written style guide.</p>
                    <h4 className='fnt-wght-800 ltr-spcng-normal m-b-0'>Verbal</h4>
                    <p className='m-b--75 m-t-0'>Effectively interpret other's body language, control ones own, and use non-verbal cues to enhance communication.</p>
                    <p className='m-t--75 m-b--75'>Profanest (?) presentation delivery - using eye contact, positive body language, voice projection, reading audience ques, and minimal notes-/reading from the slide.</p>
                </div>
            </div>
            <SkillDivider 
                dividerClassNames={['bg-secondary', 'p-t--50', 'p-b--50', 'skill-divider-container']}
                headingLevel={4}
                skillLevels={undefined}
                headingClassNames={['clr-white', 'fnt-wght-500', 'm-0']}
                dividerText='INTERMEDIATE SKILL: Adaptability'
                tooltipContent={""}
            />
            <div className='core-desktop-max-width bottom'>
                <div className='bordered-cell'>
                    <IconHoverButton
                        isLink={true}
                        linkURL='/bookmarkSkill'
                        buttonClassName='m-t--75 gap--25 p--50 bdr-radius--25'
                        buttonClassHoverName='bg-primary'
                        iconClassName='icon-primary bookmark-icons'
                        buttonOnClick={null}
                        iconHoverClassName='icon-white bookmark-icons'
                        iconName='icon-bookmark-skill'
                        iconHoverName='icon-bookmark-skill'
                        buttonText='Bookmark Skill'
                        buttonTextClassName='wht-spc-no-wrap clr-primary fnt-wght-500'
                        buttonTextHoverClassName='clr-white' />
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Recognizes and adapts to change with minimal disruption to workflow and performance level after initial adjustment period.</p>
                    <p className='m-t--75 m-b--75'>May show stress but is able to regain calm and professional demeanor.</p>
                    <p className='m-t--75 m-b--75'>Collaborate with senior staff to adopt new processes or other results of change.</p>
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Displays a positive demeanor toward change while remaining calm and professional.</p>
                    <p className='m-t--75 m-b--75'>Generates thoughtful questions toward change to better understand what's coming.</p>
                    <p className='m-t--75 m-b--75'>Utilize stressful situations as learning experiences and apply leasons learned to other situations.</p>
                </div>
                <div className='bordered-cell'>
                    <p className='m-t--75 m-b--75'>Easily adapts to change while maintaing high performance levels.</p>
                    <p className='m-t--75 m-b--75'>Embraces change by understanding and explaining the why and how to others.</p>
                    <p className='m-t--75 m-b--75'>Proactively seeks out information related to change.</p>
                </div>
            </div>
        </>);
    }

};
export default Core;